export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString("nl-BE", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
